import {
    GET_CATEGORIES_BEGIN, GET_CATEGORIES_SUCCESS, GET_CUSTOMER_FAILURE,
    POST_COMPANY_FORM_BEGIN, POST_COMPANY_FORM_SUCCESS, POST_COMPANY_FORM_FAILURE
} from '../constants/ActionTypes'

const initialState = {
    isLoadingCompanyForm: false,
    hasErrorCompanyForm: null,
    companyFormData: null,
    wasSuccessfulCompanyForm: false,
    hasCompanyForm: false,

    isLoadingCategories: false,
    hasErrorCategories: null,
    categoriesData: null,
    wasSuccessfulCategories: false,
}

/**
 * Reducer function for handling company form actions.
 *
 * @author Isadora Botassari
 * @param {Object} state - The current state of the company form.
 * @param {Object} action - The action object.
 * @returns {Object} - The new state of the company form.
 */
const ReducerCompanyForm = (state = initialState, action) => {
    switch (action.type) {

    // Post Company Form
    case POST_COMPANY_FORM_BEGIN: {
        return {
            ...state,
            isLoadingCompanyForm: true
        }
    }
    case POST_COMPANY_FORM_SUCCESS: {
        return {
            ...state,
            companyFormData: action.payload,
            isLoadingCompanyForm: false,
            hasCompanyForm: true,
            hasErrorCompanyForm: null
        }
    }
    case POST_COMPANY_FORM_FAILURE: {
        return {
            ...state,
            companyFormData: null,
            isLoadingCompanyForm: false,
            hasErrorCompanyForm: action.payload
        }
    }

    // get categories
    case GET_CATEGORIES_BEGIN: {
        return {
            ...state,
            isLoadingCategories: true
        }
    }
    case GET_CATEGORIES_SUCCESS: {
        return {
            ...state,
            categoriesData: action.payload,
            isLoadingCategories: false,
            hasErrorCategories: null
        }
    }
    case GET_CUSTOMER_FAILURE: {
        return {
            ...state,
            categoriesData: {
                names: []
            },
            isLoadingCategories: false,
            hasErrorCategories: action.payload
        }
    }

    default: return state

    }
}

export default ReducerCompanyForm